import Headroom from "headroom.js"
import lozad from "lozad";
import sal from "sal.js";

export default {
    init() {
        /**
         * Global header search functionality
         */
        $(".js-search").click(function () {
            // Because we are locking the body we need to scroll to top in case the position is off
            const $body = $("body");

            $("html, body").animate({
                scrollTop: 0,
            });

            $(this).toggleClass("is-active");
            $(".search-overlay").toggleClass("is-active");
            $body.toggleClass("is-search-overlay-active");

            if ($body.hasClass("is-search-overlay-active")) {
                document.querySelector("#search").focus();
            }
        });

        /**
         * Mobile Navigation
         */
        const hamburger = document.querySelector(".hamburger");
        if (hamburger !== null) {
            hamburger.addEventListener("click", () => {
                let active = document.body.classList.toggle('nav-is-open');
                hamburger.classList.toggle('is-active', active);

                $("#fp-nav").fadeToggle();
            });
        }

        /**
         * Sticky Header (Headroom)
         */
        const stickyHeader = document.querySelector(".novus-sticky-header");
        if(stickyHeader !== null) {
            window.headroom = new Headroom(document.querySelector(".novus-sticky-header"), {
            tolerance: 10,
            offset: 200,
                classes: {
                    initial: 'novus-sticky-header--default',
                    pinned: 'novus-sticky-header--pinned',
                    unpinned: 'novus-sticky-header--unpinned',
                },
            }).init();
        }

        /**
         * Init lazy load images
         */
        const lazyLoad = lozad(".lozad", {
            loaded: (el) => {
                el.classList.add('lozad-loaded');

                el.onload = function () {
                    this.classList.add('lozad-image-loaded');
                }
            },
        });
        lazyLoad.observe();

        /**
         * Setup intersection observer
         * for animating in divs
         */
        sal({
            threshold: 0.33,
        });


        /**
         * Init mobile navigation
         */
        $(".mobile-navigation__item--has-children .mobile-navigation__button").click(function () {
            var active = $(this).closest('li').hasClass('show-children');

            $(".mobile-navigation__item--has-children .mobile-navigation__button").each(function () {
                // find the parent list item
                let $parentLi = $(this).closest("li.mobile-navigation__item");

                // find the child sub menu and slide it down
                $parentLi.find(".mobile-navigation__sub-menu").stop().slideUp(() => {
                    $parentLi.removeClass("show-children")
                })
            });

            if (!active) {
                let $parentLi = $(this).closest("li.mobile-navigation__item");
                $(".mobile-navigation__sub-menu", $parentLi).stop().slideDown(() => {
                    $parentLi.addClass('show-children');
                })
            }
        })
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js